const makeScriptPromise = src =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;

    script.addEventListener('load', () => resolve());
    script.addEventListener('error', e => reject(e));

    document.body.appendChild(script);
  });

export default makeScriptPromise;



// WEBPACK FOOTER //
// ./src/lib/makeScriptPromise.js